<template>
    <div class="manual-upload-xml">
        <b-loading is-full-page :active="isLoading"></b-loading>
        <b-notification v-if="error" type="is-danger is-light" aria-close-label="Close notification" role="alert">{{ error }}</b-notification>

        <div class="card">
            <div class="card-content">
                <h2 class="title">Upload file</h2>

                <b-field label="Product">
                    <b-select expanded v-model="product">
                        <option
                            v-for="option in products"
                            :value="option.name"
                            :key="option.id">
                            {{ option.name }}
                        </option>
                    </b-select>
                </b-field>

                <b-field label="Test run name">
                    <b-input v-model="testRunName"/>
                </b-field>

                <b-field label="Logs url (optional)">
                    <b-input v-model="logsUrl"/>
                </b-field>

                <b-field v-if="!file">
                    <b-upload v-model="file"
                              drag-drop>
                        <section class="section">
                            <div class="content has-text-centered">
                                <p>
                                    <b-icon
                                        icon="upload"
                                        size="is-large">
                                    </b-icon>
                                </p>
                                <p>Drop your files here or click to upload</p>
                            </div>
                        </section>
                    </b-upload>
                </b-field>

                <b-field label="Selected file" v-if="file">
                    <b-tag attached
                           closable
                           aria-close-label="Remove"
                           @close="file = null">
                        {{ file.name }}
                    </b-tag>
                </b-field>

                <b-button :disabled="!isValid"
                          :loading="isUploading"
                          @click="onSubmit"
                          type="is-primary"
                          expanded>
                    Upload
                </b-button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import api from "@/api/api";

export default {
    name: "ManualUploadXml",
    data() {
        return {
            testRunName: '',
            logsUrl: '',
            product: '',
            error: null,
            isLoading: false,
            isUploading: false,
            file: null,
        }
    },
    computed: {
        ...mapGetters('TargetBuilds', [
            'products',
        ]),
        ...mapGetters('Auth', [
            'hasAccess',
        ]),
        isValid() {
            return this.file != null && this.testRunName.length > 0 && this.product.length > 0;
        }
    },
    methods: {
        ...mapActions('Platforms', [
            'fetchPlatforms',
        ]),
        ...mapActions('TargetBuilds', [
            'fetchProducts',
        ]),
        fetchData() {
            return [
                this.fetchPlatforms(),
                this.fetchProducts(),
            ];
        },
        async onSubmit() {
            if (!this.hasAccess) return;
            this.isUploading = true;
            try {
                await api.testResults.uploadTestResults({
                    file: this.file,
                    product: this.product,
                    name: this.testRunName,
                    logsUrl: this.logsUrl,
                });
                this.$buefy.toast.open({
                    duration: 10000,
                    message: 'The file is uploaded, the results will be processed after a while',
                });
                this.file = null;
                this.product = '';
                this.testRunName = '';
                this.logsUrl = '';
            } catch (error) {
                this.error = error;
            } finally {
                this.isUploading = false;
            }
        }
    },
    async created() {
        this.isLoading = true;
        await Promise.all(this.fetchData());
        this.isLoading = false;
    }
}
</script>

<style lang="scss" scoped>
.manual-upload-xml {
    height: 80vh;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>